@if (downloadUrl && downloadMode === 'IndirectDownload') {
  <div class="menu-button-and-progress">
    @if (!isNative && isDownloading) {
      <div class="menu-button hover-effect" (click)="abortDownload()">
        <ion-icon name="close-outline"></ion-icon>
      </div>
    }
    @if (!isNative && isDownloading) {
      <b>{{loadingMessage}}</b>
    }
    @if (!isNative && isDownloading) {
      <ion-spinner name="crescent"></ion-spinner>
    }
    @if (!isNative && !isDownloading || isNative) {
      <div class="menu-button" [ngClass]="{'hover-effect': !isNative}" (click)="menuButtonClicked()">
        <ion-icon [name]="menuIcon"></ion-icon>
      </div>
    }
  </div>
}

@if (downloadUrl && downloadMode === 'DirectDownload') {
  <div class="hyperlink-content">
    @if (isNative) {
      <fa-icon [icon]="faIcon" (click)="anchorClicked()"></fa-icon>
      <div class="anchor-line" (click)="anchorClicked()">
        <ion-icon name="open-outline"></ion-icon>
        <a>{{clearFileName}}</a>
      </div>
    }
    @else {
      <div class="anchor-line">
        <a [href]="downloadUrl" target="_blank" rel="noopener noreferrer" [attr.download]="clearFileName">
          <fa-icon [icon]="faIcon"></fa-icon>
          {{clearFileName}}
        </a>
      </div>
    }
  </div>
}

@if (downloadUrl && isNative) {
  <ion-action-sheet [isOpen]="menuIsOpen" [buttons]="menuOptions"
    (didDismiss)="handleSelectedMenuOption($event)">
  </ion-action-sheet>
}

@if (!isNative && downloadMode !== 'IndirectDownload' || isNative) {
  <cancelable-loading [isOpen]="isDownloading"
    [loadingMsg]="loadingMessage" [cancelFn]="abortDownload"></cancelable-loading>
}

@if (isNative) {
  <permission-onboarding #permissionOnboardingRef>
  </permission-onboarding>
}